import { Component } from '@angular/core';
import { ServerService } from 'src/app/services/server/server.service';

@Component({
  selector: 'app-master-data-page',
  templateUrl: './master-data-page.component.html',
  styleUrls: ['./master-data-page.component.scss'],
  standalone: false,
})
export class MasterDataPageComponent {
  items: Array<any> = [];

  constructor(private server: ServerService) {
    this.server.onGetMaterDataItems().subscribe({
      next: (res) => {
        if (res.success === true) {
          this.items = res.obj;
        }
      },
      error: (err) => {
        console.log(err);
      },
    });
  }
}
